export default function waitForUsabilla(callback) {
  let count = 0;
  const waitForUsabillaLiveToLoad = () => {
    if (window && window.usabilla_live) {
      count = 0;
      callback();
    } else {
      count += 1;
      if (count < 10) {
        setTimeout(waitForUsabillaLiveToLoad, 250);
      } else {
        // Give up and reset count
        count = 0;
      }
    }
  };

  waitForUsabillaLiveToLoad();
}
